<template>
    <custom-combo-box
            ref="combobox"
            class="work-mode-switch"
            :options="workModeOptions"
            :dropdown-menu-alignment="1"
            :dropdown-menu-offset-top="-24"
            dropdown-menu-header="Work Mode"
            @userSelectOption="onWorkModeSelectChange"
            :initial-value="workMode"
            theme="light"></custom-combo-box>
</template>

<script>
    import {userSettingsManager, workModeEdit, workModeRead} from "@/utils";
    import CustomComboBox from "@/InputControls/CustomComboBox";

    const workModeOptions = [
        {
            value: workModeEdit,
            label: 'Edit Mode',
        },
        {
            value: workModeRead,
            label: 'Read Mode'
        }
    ];

    export default {
        name: "WorkModeSwitch",
        components: {CustomComboBox,},
        data() {
            return {
                workModeOptions: workModeOptions,
            }
        },
        methods: {
            onWorkModeSelectChange(newVal) {
                if (newVal === this.workMode) {
                    return;
                }
                if (newVal === workModeRead && this.$store.state.existsUnsavedChanges) {
                    alert('You cannot switch to Read Mode while having unsaved changes!');
                    this.$refs.combobox.setInputValue(workModeEdit);
                    return;
                }

                userSettingsManager.setWorkMode(newVal);
            }
        },
        computed: {
            workMode() {
                return userSettingsManager.getWorkMode();
            },
        },
        watch: {
            workMode(newVal) {
                this.$refs.combobox.setInputValue(newVal);
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../assets/variables";

</style>
<style lang="scss">
    .work-mode-switch {
        .trigger-button {
            font-weight: 500;
            &:hover {
                opacity: 0.8;
            }
        }
    }
</style>
